import React, { useState } from 'react';
import { ChatInterface, ChatMessage } from '@/components/lesson/project-tracker/shared/ChatInterface';
import { NeomorphicCard } from '@/components/shared/NeomorphicCard';

/**
 * TestQuickReplies - Debug Component
 * Tests if quick reply buttons render correctly
 */
export default function TestQuickReplies() {
  const [messages, setMessages] = useState<ChatMessage[]>([
    {
      id: '1',
      content: "Hi! This is a test message. You should see 3 blue buttons below this message.",
      isUser: false,
      timestamp: new Date(),
      quickReplies: [
        "Option 1",
        "Option 2",
        "Option 3"
      ],
    },
  ]);

  const [isTyping, setIsTyping] = useState(false);

  const handleSend = (message: string) => {
    console.log('Message sent:', message);

    setMessages(prev => [
      ...prev,
      {
        id: Date.now().toString(),
        content: message,
        isUser: true,
        timestamp: new Date()
      }
    ]);

    setIsTyping(true);

    setTimeout(() => {
      setMessages(prev => [
        ...prev,
        {
          id: (Date.now() + 1).toString(),
          content: `You clicked: "${message}". Here are more options:`,
          isUser: false,
          timestamp: new Date(),
          quickReplies: ["Another 1", "Another 2", "Another 3"]
        }
      ]);
      setIsTyping(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-white p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-4">Quick Reply Test</h1>
        <p className="text-gray-600 mb-6">
          This tests if quick reply buttons render correctly.
          Open console to see debug logs.
        </p>

        <NeomorphicCard borderAccent="blue" className="h-[600px]">
          <ChatInterface
            messages={messages}
            isTyping={isTyping}
            onSendMessage={handleSend}
            setupState={{
              hasProjectName: false,
              hasTimeline: false,
              hasBudget: false,
              hasTeamSize: false
            }}
          />
        </NeomorphicCard>

        <div className="mt-4 p-4 bg-gray-100 rounded text-xs font-mono">
          <pre>{JSON.stringify(messages, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
}